export default __webpack_public_path__ + "static/media/pin.e7fcb5af.svg";